import React from 'react';
import Helmet from 'react-helmet';
import Layout from '../../shared/components/Layout/Layout';
import AIProgramImportLayout from './AIProgramImportLayout';

const AIProgramImport = () => (
  <Layout fullWidth>
    <Helmet>
      <title>Import Program | TeamBuildr</title>
    </Helmet>
    <AIProgramImportLayout />
  </Layout>
);

export default AIProgramImport;
